import {Badge} from '@mantine/core';
import {PaymentEventStatus} from '../types';

const colorFor = (status: PaymentEventStatus): string => {
    switch (status) {
        case 'Paid':
            return 'green';
        case 'Failed':
            return 'red';
        case 'Refunded':
            return 'gray';
        default:
            return 'gray';
    }
};

export const PaymentEventStatusBadge = ({status}: {status: PaymentEventStatus}) => {
    return <Badge color={colorFor(status)}>{status}</Badge>;
};
